import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { bookings } from "../../../../../redux/bookings/action";
import { selectBookingsListItems } from "../../../../../redux/bookings/selector";
import { selectListItems } from "../../../../../redux/library/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const ManagementBookings = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectBookingsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'LogisticsOrderId', headerName: 'Order ID', sortable: true },

      { field: 'InvoiceNumber', headerName: 'InvoiceNumber', searchField: 'InvoiceNumber', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'LogisticsOrderBookingStatusId', headerName: 'Booking Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: {
          library: libraryData?.result?.LogisticsBookingStatus
        },
        sortable: true,
        filter: false, isRowColorDecider: true
      },
      { field: 'ShippedDateUtc', headerName: 'Scheduled Date', isDateValueFormat: true },
      { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }
  const fetchBookings = () => {
    dispatch(bookings.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/transport/logistics/order-bookings/fetch`, entity: 'bookings', jsonData: {
        "Context": {},
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "LogisticsOrderBookingId",
          "SortOrder": "desc",
        }
      }
    }));
  }
  useEffect(() => {
    createColumnDefs()
    fetchBookings()
  }, [pageData, pageSize])

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleDelete = (data: any) => {
    dispatch(bookings.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/transport/logistics/order-bookings/delete`,
      entity: 'bookings',
      jsonData: {
        Records: [
          {
            Id: data?.LogisticsOrderBookingId
          }
        ]
      }
    })).then(() => {
      fetchBookings()

    });
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.LogisticsOrderBookingId}`)
  }
  const handleReloadData = () => {
    fetchBookings()
  }
  const additionButtons: any = [
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Add Bookings</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "InvoiceNumber",
        FieldText: "InvoiceNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(bookings.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/transport/logistics/order-bookings/fetch`,
      entity: 'bookings',
      jsonData: {
        "Context": {},
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "LogisticsOrderBookingId",
          "SortOrder": "desc",
          "Searches": searchCriteria,
        }
      }
    }));
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'LogisticsOrderBookingId',
          }} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Bookings" />
      }
    </>

  );
};

export default ManagementBookings;


